import { render } from "./TenantManagement.vue?vue&type=template&id=0a4dd1c4"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__